import React from "react";
import { Button } from "@material-ui/core";
import { Check, Close, Edit } from "@material-ui/icons";
import moment from "moment";

export const initialTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 1000,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const getTableColumns = params => {
    return [
        {
            title: "HN",
            align: "center",
            field: "UserMobile.hnNumber",
        },
        {
            title: "Patient",
            align: "center",
            field: "UserMobile.fullname",
        },
        {
            title: "Phone",
            align: "center",
            field: "UserMobile.phoneNumber",
        },
        {
            title: "Transaction Date",
            align: "center",
            cellStyle: { minWidth: 200 },
            field: "createdAt",
            render: row => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
        },
        {
            title: "Appointment Date",
            align: "center",
            cellStyle: { minWidth: 200 },
            field: "appointDate",
            render: row => moment(row?.appointDate).format("DD/MM/YYYY"),
        },
        {
            title: "Doctor",
            align: "center",
            cellStyle: { minWidth: 200 },
            field: "doctor",
        },
        {
            title: "Rights",
            align: "center",
            field: "rights",
            render: row => {
                if (row?.rights === "0") {
                    return "สิทธิประกันสังคม";
                } else if (row?.rights === "1") {
                    return "สิทธิทั่วไป";
                } else {
                    return null;
                }
            },
        },
        {
            title: "Status",
            align: "center",
            cellStyle: { minWidth: 150 },
            field: "status",
            render: row => {
                if (row?.status === "0") {
                    return (
                        <div className="bg-success text-white p-1 rounded d-flex justify-content-center align-items-center">
                            <div>รอการยืนยัน</div>
                        </div>
                    );
                } else if (row?.status === "1") {
                    return (
                        <div className="bg-danger text-white p-1 rounded d-flex justify-content-center align-items-center">
                            <div>ยืนยันการนัดหมาย</div>
                        </div>
                    );
                } else if (row?.status === "2") {
                    return (
                        <div className="bg-warning text-white p-1 rounded d-flex justify-content-center align-items-center">
                            <div>ยกเลิกการนัดหมาย</div>
                        </div>
                    );
                } else {
                    return null;
                }
            },
        },
        {
            title: null,
            sorting: false,
            align: "center",
            field: "status",
            hidden: !params?.thisMenuPermission?.edit,
            render: row => {
                if (row?.status === "0") {
                    return (
                        <div className="d-flex align-items-centers justify-content-around" style={{ minWidth: 80 }}>
                            <Button
                                onClick={() => params?.handleActions("cancel", row)}
                                size="small"
                                style={{ minWidth: 25 }}
                                className="btn btn-danger btn-sm">
                                <Close style={{ fontSize: 14 }} />
                            </Button>
                            <Button
                                onClick={() => params?.handleActions("confirm", row)}
                                size="small"
                                style={{ minWidth: 25 }}
                                className="btn btn-success btn-sm">
                                <Check style={{ fontSize: 14 }} />
                            </Button>
                            <Button
                                onClick={() => params?.handleActions("edit", row)}
                                size="small"
                                style={{ minWidth: 25 }}
                                className="btn btn-primary btn-sm">
                                <Edit style={{ fontSize: 14 }} />
                            </Button>
                        </div>
                    );
                } else {
                    return null;
                }
            },
        },
    ];
};
